import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=5a000f20&scoped=true&"
import script from "./product_list.vue?vue&type=script&lang=js&"
export * from "./product_list.vue?vue&type=script&lang=js&"
import style0 from "./product_list.vue?vue&type=style&index=0&id=5a000f20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a000f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a000f20')) {
      api.createRecord('5a000f20', component.options)
    } else {
      api.reload('5a000f20', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=5a000f20&scoped=true&", function () {
      api.rerender('5a000f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/products_management/components/product_list.vue"
export default component.exports